import React from 'react';
import { Link } from 'react-router-dom';
import StatusBadge from '../../../../components/ui/StatusBadge';
import { formatShortDateTime, sameText } from '../../../../utils/format';
import '../styles/session-table.css';

const Empty = () => <span className="session-table-muted">—</span>;

const PublishPills = ({ session }) => {
  if (!session.publishedOnWordpress && !session.publishedOnFaicon) return <Empty />;
  return (
    <div className="session-table-pills">
      {session.publishedOnWordpress && <span className="session-table-pill session-table-pill-wp" title="WordPress">WP</span>}
      {session.publishedOnFaicon && <span className="session-table-pill session-table-pill-fc" title="FAICON">FC</span>}
    </div>
  );
};

/** Sessions with transcript/report/publish state. Rows have a fixed height (see session-table.css). */
export default function SessionTable({ sessions, showEvent = true }) {
  return (
    <div className="session-table-wrap">
      <table className="session-table">
        <thead>
          <tr>
            <th>Session</th>
            <th>Transcript</th>
            <th>Report</th>
            <th>Published</th>
            <th>Updated</th>
          </tr>
        </thead>
        <tbody>
          {sessions.map((session) => {
            const title = session.title || session.originalFilename || 'Untitled session';
            const showEventLine = showEvent && session.eventTitle && !sameText(session.eventTitle, title);
            return (
              <tr key={session.id}>
                <td className="session-table-title-cell">
                  <Link to={`/sessions/${session.id}`} className="session-table-title">{title}</Link>
                  {showEventLine && (
                    <Link to={`/events/${session.eventId}`} className="session-table-event">{session.eventTitle}</Link>
                  )}
                </td>
                <td className="session-table-fit">
                  {session.status
                    ? <StatusBadge status={session.status} compact title={`Transcript: ${session.status}`} />
                    : <Empty />}
                </td>
                <td className="session-table-fit">
                  {session.reportStatus
                    ? <StatusBadge status={session.reportStatus} compact title={`Report: ${session.reportStatus}`} />
                    : <Empty />}
                </td>
                <td className="session-table-fit"><PublishPills session={session} /></td>
                <td className="session-table-date">{formatShortDateTime(session.updatedAt || session.createdAt)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
